import React from "react";

type NormalTextProps = {
  textContent: string;
  style?: React.CSSProperties;
};

const NormalText: React.FC<NormalTextProps> = ({ textContent, style }) => {
  return (
    <p style={{ ...styles.default, ...style }}>
      {textContent.split("\n").map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ))}
    </p>
  );
};

const styles = {
  default: {
    fontSize: "16px",
    fontWeight: 400,
    color: "#282B33",
    margin: 0,
    padding: 0,
  },
} as const;

export default NormalText;
